@if (inputElem?.options) {
  <div role="radiogroup" [attr.aria-labelledby]="inputElem.labelKey ? uuid() : null">
    @if (inputElem.labelKey) {
      <p
        [id]="uuid()"
        [ngClass]="inputElem.boldLabel ? 'fw-bold text-secondary' : ''"
        [innerHTML]="inputElem.labelKey | translate: inputElem.labelKeyParams"
        class="mb-2 {{ inputElem.labelCss }}"
      ></p>
    }
    @for (radio of inputElem?.options; track radio.value) {
      <div [ngClass]="{ 'mb-0': inputElem?.isInline || $last, 'form-check-inline': inputElem?.isInline }" class="form-check">
        <input
          [attr.data-test]="getUniqueId($index)"
          [attr.id]="getUniqueId($index)"
          [formControl]="parentForm.controls[inputElem.name]"
          [name]="inputElem.name"
          [attr.name]="inputElem.name"
          [value]="radio.value"
          [ngClass]="{
            'is-invalid': parentForm.controls[inputElem.name].errors && !parentForm.controls[inputElem.name].pristine,
            'form-check-readonly': isLoading || inputElem.isReadonly,
          }"
          (click)="isLoading || inputElem.isReadonly ? $event.preventDefault() : null"
          [attr.aria-describedby]="ariaDescribedBy || null"
          class="form-check-input"
          type="radio"
        />
        <div>
          <label
            [attr.data-test]="getUniqueId($index) + '-label'"
            [for]="getUniqueId($index)"
            [innerHTML]="radio.text | translate"
            [ngClass]="{ 'mb-1': inputElem?.isInline || $last }"
            class="form-label"
          ></label>
        </div>
      </div>
    }
  </div>
}
